<template>
  <div>
    <Head title="Neue Prüfung erstellen" />
    <h1 class="h1">
      <Link class="text-primary-400 hover:text-primary-600" href="/users">{{ __('user.singular') }}</Link>
      <span class="text-primary-400 font-medium">/ {{ __('general.create') }}</span>
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap md:-mb-8 md:-mr-6 p-5 md:p-8 text-sm md:text-base">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-4 pr-4 md:pb-8 md:pr-6 w-full lg:w-1/2" :label="__('exam.name')" />
          <text-input v-model="form.desc" :error="form.errors.desc" class="pb-4 pr-4 md:pb-8 md:pr-6 w-full lg:w-1/2" :label="__('exam.desc')" />
          <!--          <text-input v-model="form.email" :error="form.errors.email" class="pb-4 pr-4 md:pb-8 md:pr-6 w-full lg:w-1/2" :label="__('general.email')" />-->
          <!--          <text-input v-model="form.password" :error="form.errors.password" class="pb-4 pr-4 md:pb-8 md:pr-6 w-full lg:w-1/2" type="password" autocomplete="new-password" :label="__('general.password')" />-->
          <!--          <select-input v-model="form.owner" :error="form.errors.owner" class="pb-4 pr-4 md:pb-8 md:pr-6 w-full lg:w-1/2" :label="__('general.owner')">-->
          <!--            <option :value="true">{{ __('general.yes') }}</option>-->
          <!--            <option :value="false">{{ __('general.yes') }}</option>-->
          <!--          </select-input>-->
          <!--          <file-input v-model="form.photo" :error="form.errors.photo" class="pb-4 pr-4 md:pb-8 md:pr-6 w-full lg:w-1/2" type="file" accept="image/*" :label="__('general.photo')" />-->
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-primary" type="submit">{{ __('exam.create') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
// import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
// import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    // FileInput,
    Head,
    Link,
    LoadingButton,
    // SelectInput,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: '',
        desc: '',
        status: 1,
        category_id: 1,
        year: 2022,
        half: 1,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/exams')
    },
  },
}
</script>
